import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { RegisterUserPostRequestModel, RegisterUserPostResponseModel } from "@/features/user/services/user-model";

export class RegisterUserApi {
  /**
   *  利用者登録API
   */
  public postRegisterUser = async (
    param: RegisterUserPostRequestModel
  ): Promise<RegisterUserPostResponseModel> => {
    const path = `/api/users`;

    const res = await ApiClient.instance.post<RegisterUserPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
